<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <h3><span v-if="is_edit">修改</span>成果申报</h3>
    <AchievementForm :achievement="achievement" :type="type" ref="form"
                     @update="achievement !== $event && $assign(achievement, $event)"
                     :label_width="label_width + 'em'"></AchievementForm>
    <div class="text-center m-v-10">
      <el-button type="primary" size="cons" @click="submit()" :loading="submit_loading>0">提交</el-button>
      <el-button type="default" size="cons" @click="$router.back()">取消</el-button>
    </div>
  </div>
</template>

<script>
import maxBy from 'lodash/maxBy'
import keyBy from 'lodash/keyBy'
import * as Achievement from 'api/achievement'
import AchievementForm from './AchievementForm.vue'

export default {
  components: {AchievementForm},
  data () {
    return {
      ready: false,
      type: null,
      achievement: null,
      submit_loading: 0,
      label_width: 6,
    }
  },
  computed: {
    is_edit () {
      return !!this.$query.achievement_uid
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [types, achievement] = await Promise.all([
          Achievement.types(),
          this.$query.achievement_uid ? Achievement.get({uid: this.$query.achievement_uid}) : {type: this.$query.type},
        ])
        let type = keyBy(types, 'id')[achievement.type]
        this.label_width = maxBy(type.form, item => item.name.length).name.length + 2
        this.type = type
        this.achievement = achievement
        this.ready = true
      })
    },
    async submit () {
      if (!await this.$validate(this.$refs.form)) return
      this.$guard(this, 'submit_loading')(async () => {
        this.achievement = await Achievement.edit(this.achievement)
        this.$message.success('保存成功')
        this.$router.back()
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";

.block {
  padding: 20px;
  background-color: $color-block-background;
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/AchievementEdit.vue